<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.648 18.999C8.02088 18.9983 7.43039 18.7036 7.05296 18.2029C6.67553 17.7022 6.55486 17.0534 6.727 16.4505L6.985 15.5507C7.03685 15.3717 7.06311 15.1862 7.063 14.9998C7.063 13.8955 6.16757 13.0002 5.063 13.0002H3C1.89543 13.0002 1 12.105 1 11.0007V10.0009C1 9.91487 1 9.82789 1 9.74191C1.06773 7.35618 2.08069 5.09509 3.816 3.45613C5.55131 1.81718 7.8668 0.934633 10.253 1.00269C15.0081 1.18088 18.8218 4.99382 19 9.74791C19 9.83389 19 9.91987 19 10.0059C18.9972 14.9735 14.9686 18.999 10 18.999H8.648Z"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.499 9.24603C14.3594 9.24658 14.2466 9.3601 14.247 9.49969C14.2474 9.63929 14.3607 9.75221 14.5003 9.75203C14.6399 9.75184 14.753 9.63863 14.753 9.49902C14.7533 9.43167 14.7266 9.36701 14.6788 9.31948C14.6311 9.27194 14.5664 9.24549 14.499 9.24603"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.499 5.24752C10.3965 5.24794 10.3043 5.31016 10.2657 5.4051C10.227 5.50004 10.2495 5.60893 10.3225 5.68084C10.3956 5.75274 10.5048 5.77346 10.5991 5.7333C10.6934 5.69313 10.7542 5.60003 10.753 5.49752C10.7533 5.43017 10.7265 5.36551 10.6788 5.31797C10.6311 5.27044 10.5663 5.24399 10.499 5.24452"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.498 6.24604C6.35854 6.24714 6.24627 6.36089 6.247 6.50036C6.24774 6.63982 6.36119 6.75239 6.50066 6.75203C6.64013 6.75166 6.75299 6.6385 6.753 6.49904C6.75327 6.43151 6.72643 6.36669 6.67849 6.31913C6.63055 6.27156 6.56553 6.24523 6.498 6.24604"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.499 13.246C13.3594 13.2466 13.2466 13.3601 13.247 13.4997C13.2474 13.6393 13.3607 13.7522 13.5003 13.752C13.6399 13.7518 13.753 13.6386 13.753 13.499C13.7535 13.4316 13.7269 13.3668 13.6791 13.3192C13.6314 13.2716 13.5664 13.2452 13.499 13.246"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.499 6.24603C13.3594 6.24659 13.2466 6.3601 13.247 6.4997C13.2474 6.63929 13.3607 6.75221 13.5003 6.75203C13.6399 6.75185 13.753 6.63863 13.753 6.49903C13.7535 6.4316 13.7269 6.36678 13.6791 6.31918C13.6314 6.27159 13.5664 6.24523 13.499 6.24603"
      stroke="#EB704B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
